import { Renderer, MAP_ELEMENT, CONFIG } from "./renderer.interface";
import { Observable, of, from, empty, combineLatest, forkJoin } from "rxjs";
import { loadModules } from "esri-loader";
import { map, concatMap } from "rxjs/operators";
import { Injector } from "@angular/core";
import esri = __esri;
import { GisMapHelpersService } from "../../../services/gis-map-helpers.service";
import { GeometryType } from "../../../../builder/components/state/controls/config/data/well-related/gis-map/geometry-manager/models/geometry.model";
import { GeometryLayer } from "../../../../builder/components/state/controls/config/data/well-related/gis-map/geometry-manager/models/geometry-layer.model";
import { GeometryFactory } from "../../../../builder/components/state/controls/config/data/well-related/gis-map/geometry-manager/factories/geometry.factory";

export class Renderer2D extends Renderer<esri.MapView> {
    
    protected map: esri.Map;

    public constructor(injector: Injector) {
        super(injector);

        this.config = Object.assign(this.defaultConfig(), injector.get(CONFIG, this.defaultConfig()));
        this.config.properties = Object.assign(this.defaultConfig().properties, this.config.properties);
        this.containerElement = injector.get(MAP_ELEMENT);
    }

    defaultConfig() {
        return {
            properties: {
                basemap: this.baseMap,
                zoom: 18,
                center: [-82.965020, 40.059260 ]
            } as esri.MapProperties,
            widgets: []
        };
    }

    render(): Observable<any> {        
        return this._loadLayers();
    }

    initialize(): Observable<esri.MapView> {
        this.config = Object.assign(this.defaultConfig(), this.injector.get(CONFIG, this.defaultConfig()));
        this.config.properties = Object.assign(this.defaultConfig().properties, this.config.properties);

        return from(loadModules([
            "esri/Map",
            "esri/views/MapView",
        ])).pipe(concatMap(([EsriMap, MapView]) => {
            this.map = new EsriMap(this.config.properties);
            let mapProps = {
                container: this.containerElement,
                center: this.config.properties.center,
                zoom: this.config.properties.zoom,
                map: this.map,
                constraints: {
                    snapToZoom: false,
                    rotationEnabled: false
                }
            };

            this._view = new MapView(mapProps);

            return this.createWidgets().pipe(map(() => this._view));
        }));
    }


    public _loadLayers(): Observable<any> {        
        if (!this.config.layers)
            return empty();

        let layerService = this.injector.get(GisMapHelpersService);
        let geometry$ = this._loadGeometry();
        let layers$ = layerService.addLayers(this.map, this.config.layers);
        return forkJoin([geometry$, layers$]);       
    }

    public _loadGeometry(): Observable<any> {
                if (!this.config.geometry)
            return empty();

        let layers: GeometryLayer[] = this.config.geometry.layers;
        return from(loadModules([
            "esri/layers/GraphicsLayer",
            "esri/Graphic",
            "esri/geometry/geometryEngine"
        ])).pipe(map(([GraphicsLayer, Graphic, geometryEngine]) => {
                        let tempLayers = [];
            for (let item of layers) {
                let graphics = [];

                if (item.geometry)
                    item.geometry.forEach(x => {
                        let item = GeometryFactory.CreateGeometry(x).geom(Graphic, geometryEngine);
                        if (item)
                            graphics.push(item);
                    });

                for (let graphic of graphics) {
                    if (!graphic.symbol)
                        continue;

                    let symbol = graphic.symbol.clone();
                    symbol.color = item.color;
                    graphic.symbol = symbol;
                }

                let layer = new GraphicsLayer({
                    id: item.identifier,
                    title: item.title,
                    graphics: graphics
                });

                this.map.layers.add(layer, 0);
            }
        }));
    }

    export(): Observable<any> {
        return from(this.view.takeScreenshot());
    }
}
